import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import InboxDetail from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.inboxDetail,
    component: InboxDetail,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
